const storeName = 'STORE-LOCATOR';

export default {
    GET_STORES: `${storeName}.GET_STORES`,
    GET_STORES_LETTERS: `${storeName}.GET_STORES_LETTERS`,
    GET_SUGGESTED_STORES: `${storeName}.GET_SUGGESTED_STORES`,
    SET_STORES_DATA: `${storeName}.SET_STORES_DATA`,
    SET_RTS_STORES_DATA: `${storeName}.SET_RTS_STORES_DATA`,
    SELECT_STORE: `${storeName}.SELECT_STORE`,
    SET_ERROR_STATE: `${storeName}.SET_ERROR_STATE`,
    SET_QUERY_VALUE: `${storeName}.SET_QUERY_VALUE`,
    LOAD_GOOGLE_MAPS_API: `${storeName}.LOAD_GOOGLE_MAPS_API`,
    SET_GOOGLE_MAPS_API_LOADED: `${storeName}.SET_GOOGLE_MAPS_API_LOADED`,
    SAVE_API_PARAMETERS: `${storeName}.SAVE_API_PARAMETERS`,
    GET_PAGE: `${storeName}.GET_PAGE`,
    APPLY_DELIVERY_POST_POINT: `${storeName}.APPLY_DELIVERY_POST_POINT`,
    GET_STORES_BY_TOWN: `${storeName}.GET_STORES_BY_TOWN`,
    SET_CURRENT_PAGE: `${storeName}.SET_CURRENT_PAGE`,
    SET_PICK_UP_EXPRESS_STOREID: `${storeName}.SET_PICK_UP_EXPRESS_STOREID`,
    REQUEST_POST_POINT_DELIVERY: `${storeName}.REQUEST_POST_POINT_DELIVERY`,
    SET_ERROR_TYPE: `${storeName}.SET_ERROR_TYPE`,
    RESET_ERROR: `${storeName}.RESET_ERROR`,
};
